import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Config from "./../config.json";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${Config.IPM_SERVER_URL}/api/users/`,
    credentials: "include",
    headers: {
      "X-API-Key": Config.X_API_KEY,
    },
  }),
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: () => ({
        url: "getAll",
        params: {},
        method: "GET",
      }),
      providesTags: (result) => [
        { type: "User", id: "List" },
        ...(result ?? []).map((user) => ({ type: "User", id: user.id })),
      ],
    }),
    userLogOut: builder.mutation({
      query: () => ({
        url: "logout",
        params: {},
        method: "GET",
      }),
    }),

    getUser: builder.query({
      query: () => ({
        url: "getuser",
        method: "GET",
        params: {},
      }),
    }),
    userLogin: builder.mutation({
      query: (userData) => ({
        url: "login",
        method: "POST",
        body: userData,
      }),
    }),
    changeUserRole: builder.mutation({
      query: (userData) => ({
        url: `updateuserrole/${userData.UId}`,
        method: "PUT",
        body: userData,
      }),
      invalidatesTags: [
        { type: "User", id: "List" },
        { type: "User", id: (id) => id },
      ],
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `deleteuser/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [
        { type: "User", id: "List" },
        { type: "User", id: (id) => id },
      ],
    }),
    getUserById: builder.query({
      query: (id) => ({
        url: `get-user/${id}`,
        method: "GET",
      })
    }),

    registerUser: builder.mutation({
      query: (userData) => ({
        url: "register",
        method: "POST",
        body: userData,
      }),
    }),
  }),
});

export const {
  useGetUserByIdQuery,
  useUserLogOutMutation,
  useDeleteUserMutation,
  useGetAllUsersQuery,
  useChangeUserRoleMutation,
  useUserLoginMutation,
  useRegisterUserMutation,
  useGetUserQuery,
} = userApi;
